const initialState = {
  treeData: [],
  loading: false,
  error: null,
  rawObjectives: [],
};

export default initialState;
